import { useQuery } from '@apollo/client/react';
import type { Preview } from '@module/GraphQL';
import { GetCareersPostsQuery, type GetCareersPostsResponse, type GetCareersPostsVariables } from "./GetCareersPosts";

interface GetCareersPostsProps extends GetCareersPostsVariables {
  preview?: Preview;
  refetch?: boolean;
}

const useGetCareersPostsQuery = ({preview, refetch, ...variables}: GetCareersPostsProps) => {
  const response = useQuery<GetCareersPostsResponse, GetCareersPostsVariables>(GetCareersPostsQuery, {
    variables,
  });
  if(!!refetch)
    response.refetch();
  return response;
};

export default useGetCareersPostsQuery;